import React from 'react';
const DrivingSchools = () => <div className="service-page"><h1>Driving Schools</h1><p>Learn to drive with the best driving schools.</p></div>;
export default DrivingSchools;
